import { IRPC } from '@prisma/studio-types'

export const BIGINT_PREFIX = 'PrismaBigInt::'
export const BYTES_PREFIX = 'PrismaBytes::'
export const DECIMAL_PREFIX = 'PrismaDecimal::'

export default function serialize<T extends IRPC>(
  msg: T['request'] | T['response']
) {
  return JSON.stringify(msg, (_, value) => {
    if (typeof value === 'bigint') {
      return BIGINT_PREFIX + value
    }

    // We check for `value.type` because Buffer.toJSON() returns this. JSON.stringify automatically replaces
    if (value?.type === 'Buffer' && Array.isArray(value?.data)) {
      return BYTES_PREFIX + Buffer.from(value.data).toString('base64')
    }

    return value
  })
}
